import React, { useEffect, useState } from "react";
// import MedicalRecordCard from "../components/MedicalRecordCard";
// import { useAtom } from "jotai";
// import { selectedUserAtom } from "../config/globalStates";
// import { useItemsFilter } from "../apis/queries";
// import { ApiEndPoint } from "../constants/constant";
// import CuModal from "./CuModal";
// import { calculateAge } from "../utils/_helpers";
import moment from "moment";

import "../css/prescriptions.css";
import { useMediaQuery } from "react-responsive";
import CuMobileModal from "../components/CuMobileModal";
import PdfViewer from "../components/PdfViewer";
import CuModal from "../../common_component/component/CuModal";
import MedicalRecordCard from "../components/MedicalRecordCard";
import Confirmation from "../../common_component/component/Confirmation";
import { getImageURL } from "../../_helper/utils/image";
import { filterByTagType } from "../../new_consultation/views/CustomField";
import { IoIosClose } from "react-icons/io";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import CuStatusMessage from "../components/CuStatusMessage";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { useDeleteItem } from "../../_helper/actions/mutation/items";
import { useSearchParams } from "react-router-dom";
import ImagePreview from "../../common_component/component/ImagePreview";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
// import { calculateAge } from "../../_helper/constant/constant";

const Prescriptions = ({ data, isLoading }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState("");
  // const [selectedUser] = useAtom(selectedUserAtom);
  const [showPreview, setShowPreview] = useState(false);
  const [mainImage, setMainImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  // const sm = !useMediaQuery({ query: "(min-width:768px)" });
  const [clinic] = useAtom(clinicAtom);
  //(data, "data pre");

  const [allData, setAllData] = useState([]);
  // const prescriptionFilter = `?filter[user_id][_eq]=${selectedUser?.id}&filter[record_type][_eq]=2&fields=id,date_created,user_id,file_id,record_type.*,description,name`;
  // const { data: prescriptionRecords } = useItemsFilter(
  //   "user_records",
  //   prescriptionFilter
  // );

  const [openPdfViewer, setOpenPdfViewer] = useState(false);

  const [pdfData, setPdfData] = useState();

  const [openMobileModal, setOpenMoileModal] = useState(false);

  // const queryforUser = `/${selectedUser?.id}?fields=full_name,allergy.*.*,medical_history.*.*,qp_cm_consultation_data.doctor_user.first_name,qp_cm_consultation_data.doctor_user.last_name,qp_cm_consultation_data.medicine_table,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.dosage.name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.frequency.name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.generic_name.name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.medicine_type.name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.unit.name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.notes,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.duration,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.medicine_name,qp_cm_consultation_data.qp_cm_medicine_table.qp_cm_medicine_data_id.notes,qp_cm_consultation_data.qp_cm_advices.id,qp_cm_consultation_data.qp_cm_advices.name,qp_cm_consultation_data.qp_cm_advices.description,qp_cm_consultation_data.test_investigation,qp_cm_consultation_data.next_visit_date,qp_cm_consultation_data.date_created,qp_cm_consultation_data.qp_cm_consultation_tags.qp_cm_tags_id.*,qp_cm_consultation_data.qp_cm_vitals.*,qp_cm_consultation_data.qp_cm_vitals.type.*&deep[qp_cm_consultation_data][_filter]`;

  // const { data, isLoading } = useItemsFilter(
  //   ApiEndPoint.QM_SC_USERS_PERSONAL_DETAILS,
  //   queryforUser,
  //   !!selectedUser?.id
  // );
  // const perceptionData = deepCopy(data);

  // //("all data-----", allData);

  const handleClick = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const handleOpenPdfViewer = (item) => {
    //(item, "PDF viewer here ");
    setPdfData(item);
    setOpenPdfViewer(!openPdfViewer);
  };

  const deleteRecordsMutation = useDeleteItem("users/");

  const handleDelete = () => {
    const payload = {
      action: "delUserRecords",
      frontend: "True",
      id: selectedDeleteId,
      clinic_id: clinic?.id,
    };
    // //(payload, "---payload-----");
    deleteRecordsMutation.mutate(
      { data: payload },
      {
        onSuccess: (data) => {
          //("on delete", data);
          setSelectedDeleteId("");
          setOpenModal(false);
        },
        onError: (data) => {
          //("on Error-----", data);
          setSelectedDeleteId("");
        },
      }
    );
  };

  const { data: consultationData, isLoading: dataLoading } = useItemsFilter(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    `?action=getConsultationData&frontend=True&clinic_id=${clinic?.id}&id=${modalData?.consultation_data[0]?.id}`,
    modalData?.consultation_data[0]?.id && clinic ? true : false
  );

  const { data: slotData } = useItemsFilter(
    ApiEndPoint.QM_SC_SLOTS,
    `?action=getSlots&backend=True&clinic_id=${clinic?.id}&patient_id=${userId}&clinic=true&completed=True`,
    userId && clinic ? true : false
  );

  const { data: tagData } = useItemsFilter(
    ApiEndPoint.MEDICINE_TAG_DATA,
    `?action=getTagTypes&clinic_id=${clinic?.id}&backend=True`,
    clinic ? true : false
  );
  // //("selected user Id -----", consultationData, selectedUser);F
  useEffect(() => {
    if (data && slotData) {
      setAllData([...data, ...slotData]);
    }
  }, [data, slotData]);

  const getTagId = (label) => {
    const setting = tagData?.find(
      (item) => item.name.toLowerCase() === label.toLowerCase()
    );
    return setting ? setting.id : null;
  };

  // const files = pdfData & pdfData.files ? pdfData.files.flat() : [];
  // //("files data------", files);
  return (
    <>
      {isLoading ? (
        <CuScreenLoader />
      ) : (
        <div className=" h-full">
          {allData && Array.isArray(allData) && allData?.length > 0 ? (
            allData.map((item, i) => (
              <div className="mt-5" key={i}>
                <MedicalRecordCard
                  item={item}
                  title="Prescriptions"
                  date={moment(item?.date_created).format("DD MMM YYYY")}
                  onClick={() => handleClick(item)}
                  handleOpenPdfViewer={() => handleOpenPdfViewer(item)}
                  handleDelete={() => (
                    setSelectedDeleteId(item?.id), setOpenModal(true)
                  )}
                />
              </div>
            ))
          ) : (
            // <CuStatusMessage
            //   heading={"You don’t have any prescription record"}
            //   description={
            //     "To add Prescription Records, Tap on the Upload New Button."
            //   }
            //   img={cufrontIcons?.NoAppointment}
            // />
            <div>You don’t have any prescription record</div>
          )}
          {dataLoading ? (
            <>
              <CuScreenLoader />
            </>
          ) : (
            <>
              {showModal && (
                <div className="w-full h-full flex justify-center items-center">
                  <CuModal closeModal={() => setShowModal(false)}>
                    <div className="h-full overflow-auto text-[10.85px] laptop:text-[10.85px] desktop:text-[14.81px] large:text-[15.81px] xlarge:text-[22.22px] leading-[12.85px] laptop:leading-[13.63px] desktop:leading-[17.04px] large:leading-[18.18px] xlarge:leading-[25.55px]">
                      <div className="w-5 h-5 cursor-pointer absolute right-4 top-2">
                        <IoIosClose
                          size={18}
                          onClick={() => setShowModal(false)}
                        />
                      </div>
                      <div className="w-full flex my-2 py-4 border-b border-[#00000033] gap-2">
                        <div className="w-[65%] flex-1 flex gap-4 flex-wrap pr-4">
                          <span>
                            {consultationData?.personal_details?.full_name}
                          </span>
                          <span>{consultationData?.personal_details?.age}</span>
                          <span className="uppercase">
                            {
                              consultationData?.personal_details?.gender.split(
                                ""
                              )[0]
                            }
                          </span>{" "}
                          <span>
                            {consultationData?.personal_details?.phone}
                          </span>
                        </div>
                        <div className=" flex justify-center gap-3">
                          <span>Visit :-</span>
                          <span>
                            {moment(consultationData?.date_created).format(
                              "MMMM DD, YYYY"
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Complain
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="lowercase mb-1 laptop:leading-[17.75px]">
                            -{" "}
                            {filterByTagType(
                              consultationData?.qp_cm_consultation_tags,
                              getTagId("complaints")
                            )?.map((el, i) => {
                              return <span>{el?.name},</span>;
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Allergies
                        </div>
                        <div className="flex-1 flex items-center">
                          -{" "}
                          {consultationData?.personal_details?.allergy?.map(
                            (el, i) => {
                              return <span key={i}>{el.name}, </span>;
                            }
                          )}
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Advice and Direction
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="lowercase mb-1 laptop:leading-[17.75px]">
                            - {consultationData?.qp_cm_advices?.description}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Test and Investigations
                        </div>
                        <div className="flex-1 flex items-center">
                          <div className="lowercase mb-1 laptop:leading-[17.75px]">
                            -{" "}
                            {filterByTagType(
                              consultationData?.qp_cm_consultation_tags,
                              getTagId("TEST & INVESTIGATION")
                            )?.map((el, i) => {
                              return <span>{el?.name},</span>;
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Diagnosis
                        </div>
                        <div className="flex-1 ">
                          <div className="lowercase mb-1 laptop:leading-[17.75px]">
                            -{" "}
                            {filterByTagType(
                              consultationData?.qp_cm_consultation_tags,
                              getTagId("DIAGNOSIS")
                            )?.map((el, i) => {
                              return <span>{el?.name},</span>;
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                        <div className="w-[20%] text-[#6D6D6D] flex justify-start items-center">
                          Medical History
                        </div>
                        <div className="flex-1 ">
                          -{" "}
                          {consultationData?.personal_details?.medical_history?.map(
                            (el, i) => {
                              return <span key={i}>{el.name}, </span>;
                            }
                          )}
                        </div>
                      </div>
                      {consultationData?.qp_cm_vitals.length > 0 && (
                        <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                          <div className="w-[25%] text-[#6D6D6D] flex justify-start items-center">
                            Vitals
                          </div>
                          <div className="w-full h-full overflow-x-auto">
                            <table className="table-auto w-full">
                              <thead>
                                <tr className="bg-[#EBF8EC]">
                                  {consultationData?.qp_cm_vitals.map(
                                    (el, i) => {
                                      return (
                                        <th
                                          key={i}
                                          className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal"
                                        >
                                          {el?.type?.label}
                                        </th>
                                      );
                                    }
                                  )}
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                <tr className="text-sm">
                                  {consultationData?.qp_cm_vitals.map(
                                    (el, i) => {
                                      return (
                                        <td
                                          key={i}
                                          className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal"
                                        >
                                          {el?.value1} {el?.type?.unit}
                                        </td>
                                      );
                                    }
                                  )}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {consultationData?.medicine_data.length > 0 && (
                        <div className="border-b border-[#00000033] w-full flex py-4 gap-2">
                          <div className="w-[25%] text-[#6D6D6D] flex justify-start items-center">
                            Medicine Details
                          </div>
                          <div className="w-full h-full overflow-x-auto">
                            <table className="table-auto w-full">
                              <thead>
                                <tr className="bg-[#EBF8EC]">
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Medicine
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Unit
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Dosage
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    When
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Frequency
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Duration
                                  </th>
                                  <th className="border border-[#00000033] p-2 text-[9.15px] laptop:text-[12.35px] text-[#6D6D6D] font-normal">
                                    Notes
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                {consultationData?.medicine_data.map(
                                  (item, i) => {
                                    return (
                                      <tr className="text-sm" key={i}>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.medicineName}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.unit.name}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.dosage.name}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.when.name}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.frequency.name}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.duration}
                                        </td>
                                        <td className="p-2 whitespace-nowrap border border-[#00000033] text-center leading-[14.2px] font-normal">
                                          {item?.notes.name}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      <div className=" flex my-2 gap-3">
                        <span>Next Visit :-</span>
                        <span>
                          {!consultationData?.next_visit_date ? (
                            ""
                          ) : (
                            <>
                              {moment(consultationData?.next_visit_date).format(
                                "MMMM DD, YYYY"
                              )}
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                  </CuModal>
                </div>
              )}
            </>
          )}

          {openPdfViewer && (
            <ImagePreview
              uploadedFile={
                pdfData?.files?.flat().length > 0
                  ? pdfData.files.flat()
                  : [{ filename: pdfData?.files_id, url: pdfData?.files_id }]
              }
              mainImage={mainImage}
              setMainImage={setMainImage}
              setShowPreview={setOpenPdfViewer}
              setSelectedIndex={setSelectedIndex}
              selectedIndex={selectedIndex}
            />
          )}

          {openModal && (
            <CuModal closeModal={() => setOpenModal(false)}>
              <Confirmation
                heading={"Delete Prescription"}
                onClick={handleDelete}
                onCancel={() => setOpenModal(false)}
                loading={deleteRecordsMutation.isLoading}
              />
            </CuModal>
          )}
        </div>
      )}
    </>
  );
};

export default Prescriptions;
